import React, { FC, useEffect, useState } from "react";
import lockImg from "assets/icons/lock.svg";
import Button from "components/Semantic/Button";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { checkCouponThunk, currentClaimFormDataThunk, transactionThunk } from "store/thunk/hcr.thunk";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface PaymentCardProps {
  hcrFee: string;
}

const PaymentCard: FC<PaymentCardProps> = ({ hcrFee }) => {
  const [paymentAmount, setPaymentAmount] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [isValidCoupon, setValidCoupon] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);
  const handleRemoveCoupon = () => {
    setCouponCode("");
    setValidCoupon(false);
    setPaymentAmount(hcrFee);
  };
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const hcrId: any = useParams();

  useEffect(() => {
    if (hcrFee) setPaymentAmount(hcrFee);
  }, [hcrFee]);

  const hcrDetails = useAppSelector((state) => state.rootReducer.hcrSlice.currentClaimForm);
  const isLoading = useAppSelector((state) => state.rootReducer.hcrSlice.transactionLoading);

  useEffect(() => {
    document.body.classList.add("overflow-hidden");

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  const submitHandler = () => {
    if (hcrDetails.isComplete) {
      navigate("/hcr/download-form/" + hcrDetails?._id);
      return;
    }

    dispatch(transactionThunk({ policyId: hcrDetails?.policyId, healthClaimFilingId: hcrDetails?._id, hcrLeadId: hcrDetails?.hcrLeadId?._id, coupon: isValidCoupon ? couponCode : "" }))
      .unwrap()
      .then(async (data) => {
        if (data?.data?.payStatus) {
          displayRazorpay(data?.data || {});
          return;
        } else {
          navigate(`/hcr/payment-success/${hcrDetails._id}`);
        }
      });
  };
  async function displayRazorpay(data: any) {
    const options: any = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: data?.amount || 799,
      name: "Insurance Samadhan",
      description: "Pay for Policies " + sessionStorage.getItem("complaintTypeId"),
      image: "https://insurancesamadhan.blob.core.windows.net/insa-partners-prod/staticImage/paymentlogo.png",
      prefill: {
        email: data.email,
        contact: data.phone
      },
      notes: [data.txnId],
      theme: {
        color: "#000000"
      },
      handler: async function () {
        try {
          navigate(`/hcr/payment-success/${hcrDetails._id}`);
          dispatch(currentClaimFormDataThunk(hcrId.id));
        } catch (error) {
          // eslint-disable-next-line
          console.log("Something went wrong");
        }
      }
    };
    const paymentObject: any = new (window as any).Razorpay(options);
    paymentObject.open();
  }

  const submitCouponHandler = () => {
    dispatch(checkCouponThunk({ coupon: couponCode, policyId: hcrDetails?.policyId?._id }))
      .unwrap()
      .then((data) => {
        if (data?.success && data?.data?.couponExist) {
          setValidCoupon(true);
          setPaymentAmount(data?.data?.feeAmount);
        }
      });
  };
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center">
      <img src={lockImg} className="-mb-6" />
      <div className="bg-overlay-gradient border-4 rounded-[10px] border-[#0000001A] p-5">
        <p className="font-extrabold text-xl text-center">Please Pay Rs {paymentAmount}</p>
        <p className="font-semibold text-center text-sm mt-1">to view complete Claim form</p>
        <p className="text-xs font-semibold text-center mt-3 border-b-[1px] pb-2 border-[#00000026] text-[#00000099]">ENTER YOUR COUPON CODE</p>
        <div className="w-full max-w-md my-3">
          <div className="flex items-center border rounded-lg overflow-hidden bg-white h-10">
            <div className="flex items-center flex-1 px-3">
              <input
                type={showCoupon ? "text" : "password"}
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value.toUpperCase());
                  setShowCoupon(false);
                }}
                placeholder="Enter coupon code"
                disabled={isValidCoupon}
                className="flex-1 text-sm font-medium text-gray-700 focus:outline-none disabled:bg-gray-100"
              />

              {!isValidCoupon && couponCode && (
                <button type="button" onClick={() => setShowCoupon((prev) => !prev)} className="text-xs text-gray-500">
                  {showCoupon ? (FaEye as unknown as React.FC)({}) : (FaEyeSlash as unknown as React.FC)({})}
                </button>
              )}
            </div>
            <button
              type="button"
              onClick={submitCouponHandler}
              disabled={!couponCode || isValidCoupon}
              className={`h-full px-4 text-sm font-semibold transition
        ${isValidCoupon ? "text-green-600 bg-green-50 cursor-default" : couponCode ? "text-blue-600 hover:bg-blue-50" : "text-gray-400 cursor-not-allowed"}
      `}
            >
              {isValidCoupon ? "APPLIED" : "APPLY"}
            </button>
          </div>

          {/* Remove Coupon */}
          {isValidCoupon && (
            <button type="button" onClick={handleRemoveCoupon} className="mt-2 ml-1 text-xs text-red-500 font-semibold">
              Remove Coupon
            </button>
          )}
        </div>
        <div className="w-full ">
          <Button isLoading={isLoading} title={<p className="text-sm">CONTINUE</p>} className="md:w-full ml-0 w-full text-sm mt-5 mx-0 h-10" onClick={submitHandler} />
        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
